<template>
	<v-container>
		<h1>Projects</h1>

		<!-- <v-card class="mx-auto" width="344">
			<v-img
				:aspect-ratio="1/1"
				:src="require('@/assets/img/e-csoport.png')"
				contain
			></v-img>
			<v-card-title>
				<v-spacer></v-spacer>
				<h1 class="headline">E-CSOPORT.HU</h1>
				<v-spacer></v-spacer>
			</v-card-title>
		</v-card> -->

		<v-hover>
			<template v-slot:default="{ hover }">
				<v-card class="mx-auto" max-width="344">
					<v-img
						src="https://cdn.vuetifyjs.com/images/cards/forest-art.jpg"
						alt="some picture"
					></v-img>
					<v-card-text>
						<h2 class="title primary--text">Magento Forests</h2>
						Travel to the best outdoor experience on planet Earth. A
						vacation you will never forget!
					</v-card-text>
					<v-card-title>
						<v-rating
							:value="4"
							dense
							color="orange"
							background-color="orange"
							hover
							class="mr-2"
						></v-rating>
						<span class="primary--text subtitle-2">64 Reviews</span>
					</v-card-title>
					<v-fade-transition>
						<v-overlay v-if="hover" absolute color="#036358">
							<v-btn>See more info</v-btn>
						</v-overlay>
					</v-fade-transition>
				</v-card>
			</template>
		</v-hover>
	</v-container>
</template>

<script>
export default {
	data: () => ({
		overlay: false
	})
};
</script>
